import { render } from "./aUploadImage.vue?vue&type=template&id=5b301f6b&scoped=true"
import script from "./aUploadImage.vue?vue&type=script&lang=js"
export * from "./aUploadImage.vue?vue&type=script&lang=js"

import "./aUploadImage.vue?vue&type=style&index=0&id=5b301f6b&lang=scss&scoped=true"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b301f6b"]])

export default __exports__